import React from 'react';
import Permissions from '@gogame/permissions';
import { Actions, Action, DownloadIcon } from '@gogame/components';

import { ACTION_DOWNLOAD } from 'scenes/SkanSchemes/constants';

const ActionsComponent = ({ limit = 1, onExport, actions = [] }) => {
  return (
    <Permissions actions={actions}>
      {({ isActionAllowed }) => (
        <Actions limit={limit}>
          {isActionAllowed(ACTION_DOWNLOAD) ? (
            <Action
              id={ACTION_DOWNLOAD}
              icon={<DownloadIcon />}
              label={'Export'}
              onClick={onExport}
            />
          ) : null}
        </Actions>
      )}
    </Permissions>
  );
};

export default ActionsComponent;
